import { ImplicitTagSource } from '@@types/api.types';

type ImplicitTagOption = {
  label: string;
  source: ImplicitTagSource;
  value: string;
};

export const IMPLICIT_TAG_OPTIONS: ImplicitTagOption[] = [
  { label: 'Australia', source: ImplicitTagSource.COUNTRY, value: 'AU' },
  { label: 'United Kingdom', source: ImplicitTagSource.COUNTRY, value: 'GB' },
  { label: 'United States', source: ImplicitTagSource.COUNTRY, value: 'US' },
  { label: 'Commercial', source: ImplicitTagSource.TYPE, value: 'Commercial' },
  { label: 'Research', source: ImplicitTagSource.TYPE, value: 'Research' },
  { label: 'Research Project', source: ImplicitTagSource.TYPE, value: 'Research Project' },
];

export const getImplicitTagSourceLabel = (source: ImplicitTagSource): string => {
  switch (source) {
    case ImplicitTagSource.COUNTRY:
      return 'Location';
    case ImplicitTagSource.TYPE:
      return 'Type';
    case ImplicitTagSource.SPECIAL:
      return 'Special';
    default:
      return 'Tag';
  }
};

export const isAllTagName = (tagName: string): boolean => {
  return tagName.trim().toLowerCase() === 'all';
};
